"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _RedirectAllRequestsTo_1 = require("./_RedirectAllRequestsTo");
var _IndexDocument_1 = require("./_IndexDocument");
var _ErrorDocument_1 = require("./_ErrorDocument");
var _RoutingRules_1 = require("./_RoutingRules");
exports.GetBucketWebsiteOutput = {
    type: "structure",
    required: [],
    members: {
        RedirectAllRequestsTo: {
            shape: _RedirectAllRequestsTo_1._RedirectAllRequestsTo
        },
        IndexDocument: {
            shape: _IndexDocument_1._IndexDocument
        },
        ErrorDocument: {
            shape: _ErrorDocument_1._ErrorDocument
        },
        RoutingRules: {
            shape: _RoutingRules_1._RoutingRules
        }
    }
};
//# sourceMappingURL=GetBucketWebsiteOutput.js.map